export default __webpack_public_path__ + "static/image-2-276a944a901e46730788a8a7373a94da.jpg";